Wee.fn.make('navigation', {
	init: function() {
		var priv = this.$private;

		$.screen.map([
			{
				max: 3,
				init: false,
				callback: function() {
					priv.destroyDropdownToggle();
				}
			},
			{
				max: 3,
				callback: function() {
					priv.initObservables();
					priv.initMenuEvents();
				}
			},
			{
				min: 4,
				callback: function() {
					priv.destroyMenu();
					priv.initDropdownToggle();
				}
			}
		]);
	},
	links: function() {
		$('ref:navLink').deactivate()
			.filter('[href="/' + $.routes.segments(0) + '"]')
			.activate();
	}
}, {
	/**
	 * Init mobile observables
	 *
	 * @private
	 */
	initObservables: function() {
		var	$body = $(Wee._body),
			$header = $('ref:header'),
			$menu = $('ref:menu'),
			$toggle = $('ref:toggle');

		$menu.disable();

		$.set('menu.enabled', false);

		$.observe('menu', function(data) {
			if (data.enabled) {
				$body.disable();
				$menu.enable();
				$toggle.add($header)
					.activate();
			} else {
				$body.enable();
				$menu.disable();
				$toggle.add($header)
					.deactivate();
				$('ref:navDropdownToggle').deactivate();
			}
		}, {
			recursive: true
		});
	},

	/**
	 * Init mobile events
	 *
	 * @private
	 */
	initMenuEvents: function() {
		$.events.on({
			'ref:toggle': {
				click: function(e) {
					$.set('menu.enabled', ! $.get('menu.enabled'));

					e.stopPropagation();
				}
			},
			'ref:navDropdownToggleLink': {
				click: function(e, el) {
					var $parent = $(el).parent();

					$parent.isActive() ?
						$parent.deactivate() :
						$parent.activate();

					e.preventDefault();
					e.stopPropagation();
				}
			},
			'document': {
				click: function() {
					$.set('menu.enabled', false);
				}
			}
		}, {
			namespace: 'mobile'
		});
	},

	/**
	 * Destroy mobile menu
	 *
	 * @private
	 */
	destroyMenu: function() {
		$.events.off(false, '.mobile');
		$.set('menu.enabled', false);
		$.unobserve('menu');
		$.drop('menu');
		$('ref:navDropdownToggle').deactivate();
		$('ref:menu').enable();
	},

	/**
	 * Init desktop nav dropdown toggle
	 *
	 * @private
	 */
	initDropdownToggle: function() {
		var scope = this;

		$.events.on({
			'ref:navDropdownToggle': {
				mouseenter: function(e, el) {
					if (! scope.$get('sticky')) {
						$(el).activate();
					}
				},
				mouseleave: function(e, el) {
					$(el).deactivate();
				}
			},
			'ref:navDropdownToggleLink': {
				click: function(e, el) {
					$.history.go({
						path: $(el).attr('href')
					});

					e.preventDefault();
				}
			},
			'ref:navLink': {
				click: function() {
					$('ref:navDropdownToggle').deactivate();
				}
			}
		}, {
			namespace: 'navDropdown'
		});
	},

	/**
	 * Destroy desktop nav dropdown toggle
	 *
	 * @private
	 */
	destroyDropdownToggle: function() {
		$.events.off(false, '.navDropdown');
	}
});